import { Action } from '@ngrx/store';


export enum SceneATypes {
  SCENE_GET = '[SCENE] Get ',
  SCENE_SUCCESS = '[SCENE] Success',
  SCENE_FAILURE = '[SCENE] Failure',
}

export class SceneGet implements Action {
  readonly type = SceneATypes.SCENE_GET;
  constructor(public IdUsuario: number) {}
}

export class SceneSuccess implements Action {
  readonly type = SceneATypes.SCENE_SUCCESS;
  constructor(public Scenes: any[]) {}
}

export class SceneFailure implements Action {
  readonly type = SceneATypes.SCENE_FAILURE;
  constructor(public payload: any) {}
}


export type SceneAcciones =
  | SceneGet
  | SceneSuccess
  | SceneFailure;